<template>
  <div class="sidebar-account">
    <div class="text lead mb-0">
      <span class="mr-2">{{ initials }}</span>
    </div>
    <p class="text text-muted mb-0">{{ getRoles() }}</p>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { userMappers } from '@/store/modules/user'
import { rolesTranslation } from '@/config/roles'
import AuthAPI from '@/api/requests/auth'

const Mappers = Vue.extend({
  computed: {
    ...userMappers.mapGetters(['userRoles']),
  },
})

@Component
export default class Profile extends Mappers {
  private user: any = {}

  private get initials() {
    return this.user?.initials || 'Неизвестный'
  }

  private getRoles() {
    return this.userRoles.map((r: string) => rolesTranslation[r]).join(', ')
  }

  private async created() {
    this.user = (await AuthAPI.getCurrentUser()).data
  }
}
</script>

<style lang="scss" scoped>
.text {
  padding: 0rem 1rem;
}
</style>
